import { render, staticRenderFns } from "./Update-Ot.vue?vue&type=template&id=9d6a015c"
import script from "./Update-Ot.vue?vue&type=script&lang=js"
export * from "./Update-Ot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports